import React, { useState, useEffect } from 'react';
import UserStatus from '../TogelButton/UserStatus';
import PlanServices from '../../../services/PlanServices';

function PlanUpdate({ notification, closeModal, onSuccess }) {
  const [formValues, setFormValues] = useState({
    name: "",
    description: "",
    price: 0,
    validity: 0,
    packageType: "",
  });
  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png'); 

  useEffect(() => {
    if (notification) {
      setFormValues({
        name: notification?.name || '',
        description: notification?.description || '',
        price: notification?.price || '',
        validity: notification?.validity || '',
        packageType: notification?.packageType || '',
      });
      
    }
  }, [notification]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
 
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      
      const response = await PlanServices.updatePlan(notification._id, {
        "name": formValues.name,
        "description":formValues.description,
        "price": formValues.price,
        "validity":formValues.validity,
        "packageType":formValues.packageType,
      });

      alert('Notification updated successfully');
      onSuccess();
    } catch (error) {
      console.error('Failed to update notification', error);
      alert('Failed to update notification');
    }
  };

  return (
    <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Notification Edit</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body">
            <div className="container-box px-5">
              <div className="container-box-inner">
                <div className="page-details">
                <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Package Name</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      value={formValues.name}
                      onChange={handleInputChange}
                      placeholder="Weekly"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Amount</label>
                    <input
                      type="number"
                      name="price"
                      className="form-control"
                      value={formValues.price}
                      onChange={handleInputChange}
                      placeholder="0"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Validity</label>
                    <input
                      type="number"
                      name="validity"
                      className="form-control"
                      value={formValues.validity}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Package Type</label>
                    <select
                      name="packageType"
                      className="form-control"
                      value={formValues.packageType}
                      onChange={handleInputChange}
                    >
                      <option value="">Select Type</option>
                      <option value="free">Free</option>
                      <option value="paid">Paid</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Status</label>
                    <div className="barcode-range-inner-field">
                            <p>Active/Inactive</p>
                            <div className="status-toggle">
                    <UserStatus user={notification} page={"plan"} onSuccess={onSuccess} />
                  </div>
                  </div>
                          </div>
                </div>
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Description</label>
                    <select
                      name="description"
                      className="form-control"
                      value={formValues.description}
                      onChange={handleInputChange}
                      multiple
                    >
                      <option value="Faster Data Refresh">Faster Data Refresh</option>
                      <option value="Include all Features of OTW">Include all Features of OTW</option>
                      <option value="Ad-free Experience">Ad-free Experience</option>
                      <option value="Includes all scripts and indices">Includes all scripts and indices</option>
                      <option value="No Live Webinar Access">No Live Webinar Access</option>
                    </select>
                  </div>
                </div>
              </div>
              <button type="submit" className="submit-green-btn">SUBMIT</button>
            </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlanUpdate;
